module.exports = __webpack_public_path__ + "467b290ff3b34154ec0c7eb0c381a819.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorREDWINE.jpg
// module id = 1047
// module chunks = 1